// Error messages returned by the backend that the frontend handles explicitly.
// Keep these in sync with the API responses; import from here instead of redefining them.
export const API_ERRORS = {
  INSUFFICIENT_ACCESS_LEVEL: 'insufficient access level'
} as const
